export const IS_AUTH = "IS_AUTH";
export const STORE_USER = "STORE_USER";